import React,{useEffect} from 'react'
import { Link as RouterLink, useLoaderData,createBrowserRouter, createRoutesFromElements, Navigate, Await, BrowserRouter, Route, Routes, NavLink, useNavigate, useLocation, useOutlet, useParams} from 'react-router-dom'
import {useAuth} from '../index'
import EggIcon from '../util/myegg.png'
export function MainPage1(){
  const { user2 } = useAuth()
  const navigate = useNavigate()
  useEffect(()=>{
    if (user2) {        
      navigate('/main')
    }
  })
  var TxtType = function(el, toRotate, period) {
    this.toRotate = toRotate
    this.el = el
    this.loopNum = 0
    this.period = parseInt(period, 10) || 2000
    this.txt = ''
    this.tick()
    this.isDeleting = false
  }

  TxtType.prototype.tick = function() {
    var i = this.loopNum % this.toRotate.length    
    var fullTxt = this.toRotate[i]
    if (this.isDeleting) {
      this.txt = fullTxt.substring(0, this.txt.length - 1)
    } else {
      this.txt = fullTxt.substring(0, this.txt.length + 1)
    }
    this.el.innerHTML = '<span class="wrap">'+this.txt+'</span>'

    var that = this
    var delta = 200 - Math.random() * 100

    if (this.isDeleting) { delta /= 2 }

        if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period
        this.isDeleting = true
        } else if (this.isDeleting && this.txt === '') {
        this.isDeleting = false
        this.loopNum++
        delta = 500
        }

        setTimeout(function() {
        that.tick()
        }, delta)
    }

    window.onload = function() {
        var elements = document.getElementsByClassName('typewrite')
        for (var i=0; i<elements.length; i++) {
            var toRotate = elements[i].getAttribute('data-type')
            var period = elements[i].getAttribute('data-period')
            if (toRotate) {
              new TxtType(elements[i], JSON.parse(toRotate), period)
            }
        }
        // INJECT CSS
        var css = document.createElement("style")
        css.type = "text/css"
        css.innerHTML = ".typewrite > .wrap { border-right: 0.08em solid black}"
        document.body.appendChild(css)
    }
     return(
        <div className='structure__main__content'>
        <div className='flex'>
        <h1 className='text-lg structure__main__ttl'>Dev Cookbooks</h1> 
        </div>
        <div className='w-auto sm:w-[400px] h-[26px] m-auto ml-[12px] mr-[12px] mt-[16px] mb-[16px]
        '>
         <h3 className='structure__main__typetext bitter'>
         <a href='' className='typewrite' data-period='2000' data-type='[ "Minimize your time to write the best code.","Simple and easy codes to catchup code faster.","Avoid critical errors." ]'>
            <span className='wrap'></span>
         </a>
         </h3>
        </div>
        <div className='bitter font-400 text-[11px] bg-[#147193] text-white hover:bg-[#1A6481] active:bg-[#1A6481] w-fit m-auto pt-[4px] pb-[4px] pl-[12px] pr-[12px]'><RouterLink to='/react/basic'>See All React Demo</RouterLink></div>
         {/* bg-[#414c75] hover:bg-[#365c88] text-white */}
          {/* <div className='border border-gray-950 w-fit m-auto pt-[4px] pb-[4px] pl-[12px] pr-[12px] hover:bg-[#e2e2e2] active:bg-[#e2e2e2]'><RouterLink to='/signup'>Create your account to use API/Purchase code</RouterLink></div>
         <div className='border border-gray-950 w-fit m-auto pt-[4px] pb-[4px] pl-[12px] pr-[12px] hover:bg-[#e2e2e2] active:bg-[#e2e2e2]'><RouterLink to='/react'>See React Demo</RouterLink></div> raleway font-400 */}
         <div className='w-5/6 sm:w-fit m-auto mt-[4px] mb-8 text-[14px] bitter'>Create your account today to purchase code.</div>
         <div className='w-5/6 md:w-[460px] text-[14px] m-auto'>
         <span className='bitter'>Dev Cookbooks shares simplest + sophisticated code which covers basic ∼ advanced with the latest modern technologies.</span><br/>
         <div className='cursor-default mt-2 structure__main__collectiontext'>
          <span className='hover:text-[#0d5e6b]'>react</span> | <span className='hover:text-[#0d5e6b]'>toggle button</span> | <span className='hover:text-[#0d5e6b]'>CRUD</span> | <span className='hover:text-[#0d5e6b]'>upload image</span> | <span className='hover:text-[#0d5e6b]'>generating</span> | <span className='hover:text-[#0d5e6b]'>pdf storing data</span> | <span className='hover:text-[#0d5e6b]'>admin role</span> | <span className='hover:text-[#0d5e6b]'>stripe</span> | <span className='hover:text-[#0d5e6b]'>python</span> | <span className='hover:text-[#0d5e6b]'>databases</span> | <span className='hover:text-[#0d5e6b]'>cache storage</span> | <span className='hover:text-[#0d5e6b]'>firebase</span> | <span className='hover:text-[#0d5e6b]'>mongoDB</span> | <span className='hover:text-[#0d5e6b]'>json</span> | <span className='hover:text-[#0d5e6b]'>apidAPI</span>r | <span className='hover:text-[#0d5e6b]'>Login</span> | <span className='hover:text-[#0d5e6b]'>MSAL</span> | <span className='hover:text-[#0d5e6b]'>2steps authentication</span> | <span className='hover:text-[#0d5e6b]'>OCR</span> | <span className='hover:text-[#0d5e6b]'>LLM</span>  | <span className='hover:text-[#0d5e6b]'>Generative AI</span> | <span className='hover:text-[#0d5e6b]'>Chatbot</span> | <span className='hover:text-[#0d5e6b]'>OpenAI</span> | <span className='hover:text-[#0d5e6b]'>huggingface</span> | <span className='hover:text-[#0d5e6b]'>Claude</span> | <span className='hover:text-[#0d5e6b]'>ML</span> </div>
         <br/><br/><br/>
         </div>
        {/* <h2 className='mt-4'><b>Trusted company uses our products</b></h2>
        <h2 className='mt-4'><b>How they like our products</b></h2>
          */}
        </div>
     )
}
export function MainPage2(){
   var TxtType = function(el, toRotate, period) {
        this.toRotate = toRotate
        this.el = el
        this.loopNum = 0
        this.period = parseInt(period, 10) || 2000
        this.txt = ''
        this.tick()
        this.isDeleting = false
    }

    TxtType.prototype.tick = function() {
        var i = this.loopNum % this.toRotate.length
        var fullTxt = this.toRotate[i]

        if (this.isDeleting) {
        this.txt = fullTxt.substring(0, this.txt.length - 1)
        } else {
        this.txt = fullTxt.substring(0, this.txt.length + 1)
        }

        this.el.innerHTML = '<span class="wrap">'+this.txt+'</span>'

        var that = this
        var delta = 200 - Math.random() * 100

        if (this.isDeleting) { delta /= 2 }

        if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period
        this.isDeleting = true
        } else if (this.isDeleting && this.txt === '') {
        this.isDeleting = false
        this.loopNum++
        delta = 500
        }

        setTimeout(function() {
        that.tick()
        }, delta)
    }

    window.onload = function() {
        var elements = document.getElementsByClassName('typewrite')
        for (var i=0; i<elements.length; i++) {
            var toRotate = elements[i].getAttribute('data-type')
            var period = elements[i].getAttribute('data-period')
            if (toRotate) {
              new TxtType(elements[i], JSON.parse(toRotate), period)
            }
        }
        // INJECT CSS
        var css = document.createElement("style")
        css.type = "text/css"
        css.innerHTML = ".typewrite > .wrap { border-right: 0.08em solid black}"
        document.body.appendChild(css)
    }
     return(
        <div className='structure__main__content'>
        <div className='m-auto flex-col w-fit'>
        <h1 className='text-lg structure__main__ttl mb-[0px]'>Dev Cookbooks</h1> 
        {/* <img src={EggIcon} className='m-auto w-[40px] h-auto'/> */}
        </div>
         <h3 className='structure__main__typetext md:w-[560px] m-auto h-[32px]'>
         <a href='' className='typewrite' data-period='2000' data-type='[ "Minimize your time to write a code.","Simple and easy codes to understand code faster.","Avoid critical errors." ]'>
            <span className='wrap'></span>
         </a>
         </h3>
         <div className='flex w-fit m-auto'>
         {/* <div className='border border-gray-950 w-fit m-auto pt-[4px] pb-[4px] pl-[12px] pr-[12px] hover:bg-[#e2e2e2] active:bg-[#e2e2e2]'><RouterLink to='/signup'>Create your account to use API/Purchase code</RouterLink></div> */}
         {/* <div className='border border-gray-950 w-fit m-auto pt-[4px] pb-[4px] pl-[12px] pr-[12px] hover:bg-[#e2e2e2] active:bg-[#e2e2e2] mr-[2px]'><RouterLink to='/react'>See Demo</RouterLink></div> */}
         <div className='bitter text-[11px] border-[.1px] border-gray-950 w-fit m-auto pt-[4px] pb-[4px] pl-[12px] pr-[12px] hover:bg-[#e2e2e2] active:bg-[#e2e2e2]'><RouterLink to='/signup'>Get Started</RouterLink></div>
         </div>
         <div className='w-fit m-auto mb-8'>Create your account to unlock all demo.</div>
         <div className='w-full md:w-[560px] m-auto'>
         Dev Cookbooks shares simplest + sophisticated code which covers basic ∼ advanced with the latest modern technologies.<br/>
         <div className='mt-2 structure__main__collectiontext'>react | toggle button | CRUD | upload image | generating | pdf storing data | admin role | stripe | python | databases | cache | firebase | mongoDB | json | rapidAPI | Login | MSAL | 2step authentication | OCR | LLM  | Generative AI | Chatbot | OpenAI | huggingface | Claude | ML </div>
         <br/><br/><br/><br/><br/><br/><br/>
         </div>
        {/* <h2 className='mt-4'><b>Trusted company uses our products</b></h2>
        <h2 className='mt-4'><b>How they like our products</b></h2>
          */}
        </div>
     )
}